import React from "react";
import { Turnstile } from "@marsidev/react-turnstile";

interface TurnstileWidgetProps {
  siteKey: string;
  widgetRef: React.MutableRefObject<{ reset: () => void } | undefined>;
  onSuccess: (token: string) => void;
  onExpire: () => void;
  onError?: () => void;
  appearance?: "always" | "interaction-only";
}

const TurnstileWidget: React.FC<TurnstileWidgetProps> = ({
  siteKey,
  widgetRef,
  onSuccess,
  onExpire,
  onError,
  appearance = "interaction-only",
}) => {
  if (!siteKey) return null;

  return (
    <Turnstile
      ref={widgetRef as any}
      siteKey={siteKey}
      onSuccess={onSuccess}
      onExpire={onExpire}
      onError={onError}
      options={{ size: "flexible", appearance }}
    />
  );
};

export default TurnstileWidget;
